import axios from 'axios';
import { addAppCheckToken } from '../utilities/firebase-app-check';

/**
 * Configura gli interceptor di Axios per aggiungere automaticamente
 * il token Firebase App Check a tutte le richieste
 */
export const setupAxiosInterceptors = () => {
    // Interceptor per le richieste
    axios.interceptors.request.use(
        async (config) => {
            try {
                // Inizializza gli header se non esistono
                if (!config.headers) {
                    config.headers = {} as any;
                }

                // Aggiungi il token App Check agli header
                const headersWithToken = await addAppCheckToken(config.headers as Record<string, string>);

                // Aggiorna gli header della configurazione
                config.headers = headersWithToken as any;
            } catch (error) {
                // Se c'è un errore, logga ma procedi con la richiesta
                console.error('Error adding App Check token to request:', error);
            }

            return config;
        },
        (error) => {
            return Promise.reject(error);
        },
    );

    // Interceptor per le risposte (opzionale, per gestire errori specifici di App Check)
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            // Gestisci errori specifici legati ad App Check
            if (error.response?.status === 401 && error.response?.data?.error?.includes('App Check')) {
                console.error('App Check authentication failed:', error.response.data);
            }
            return Promise.reject(error);
        },
    );
};
